import { flattenProducts } from '@fff-web/fff-cart';
import { campaignId, getCampaignType } from '../../utils/campaign';
import env from '../../utils/env';
import request from './request';

export function requestCartData() {
  const type = getCampaignType();
  let requestUrl = `${env.aceApi}api/1/carts/campaigns?type=${type}`;
  if (campaignId !== null) {
    requestUrl += `&campaignId=${campaignId}`;
  }
  return request(requestUrl);
}

export async function getCartData() {
  const {
    products: productsWithVariants,
    cartDetails,
    customizeCampaignDetails,
  } = await requestCartData();
  const { products, variants } = flattenProducts(productsWithVariants);
  return {
    products,
    variants,
    cartDetails: { ...cartDetails, customizeCampaignDetails },
  };
}

export function getPurchasedVariants(campaignIdNumber: number, campaignType: string) {
  const requestUrl = `${env.aceApi}api/1/carts/campaigns/${campaignIdNumber}/purchases?type=${campaignType}`;
  return request(requestUrl);
}
